var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "vip-home-card",
      attrs: {
        "aria-label": _vm.$t("personalCenter.vip_member"),
        "aria-busy": _vm.isLoading ? "true" : "false",
      },
    },
    [
      _c("div", { staticClass: "vip-home-main" }, [
        _vm.memberLevel === 0
          ? _c(
              "div",
              {
                staticClass: "vip-home-emblem",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("VIP0")]
            )
          : _c("div", { staticClass: "vip-home-emblem-photo" }, [
              _c("img", {
                staticClass: "vip-home-emblem-image",
                attrs: { src: _vm.emblemImage, alt: "VIP" + _vm.memberLevel },
                on: {
                  error: function ($event) {
                    _vm.useFallbackEmblemImage = true
                  },
                },
              }),
            ]),
        _c("div", { staticClass: "vip-home-copy" }, [
          _c("div", { staticClass: "vip-home-heading" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("member_level.title")))]),
            _c(
              "strong",
              {
                staticClass: "vip-home-level-name",
                attrs: { title: _vm.memberLevelName },
              },
              [
                _vm.levelNameParts.isVip
                  ? [
                      _vm._m(0),
                      _c("span", { staticClass: "vip-home-level-number" }, [
                        _vm._v(_vm._s(_vm.levelNameParts.suffix)),
                      ]),
                    ]
                  : _c("span", { staticClass: "vip-home-level-text" }, [
                      _vm._v(_vm._s(_vm.memberLevelName)),
                    ]),
              ],
              2
            ),
          ]),
          _c("p", { staticClass: "vip-home-points" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("member_level.points_progress"))),
            ]),
            _c(
              "strong",
              [
                _vm._v(_vm._s(_vm.formatNumber(_vm.currentPoints))),
                !_vm.isMaxLevel
                  ? [
                      _vm._v(
                        " / " + _vm._s(_vm.formatNumber(_vm.nextLevelPoints))
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "vip-home-progress",
              attrs: {
                role: "progressbar",
                "aria-valuemin": "0",
                "aria-valuemax": _vm.isMaxLevel ? 100 : _vm.nextLevelPoints,
                "aria-valuenow": _vm.isMaxLevel ? 100 : _vm.currentPoints,
              },
            },
            [_c("span", { style: { width: _vm.progressDisplayPercent + "%" } })]
          ),
          _vm.isMaxLevel
            ? _c("p", { staticClass: "vip-home-next vip-home-max-level" }, [
                _c("i", {
                  staticClass: "el-icon-trophy",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("personalCenter.vip.max_level")) +
                    "\n\t\t\t"
                ),
              ])
            : _c("p", { staticClass: "vip-home-next" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t("member_level.next_level", {
                        level: _vm.nextLevel,
                      })
                    ) +
                    "\n\t\t\t\t"
                ),
                _c("strong", [
                  _vm._v(_vm._s(_vm.formatNumber(_vm.remainingPoints))),
                ]),
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("member_level.points_unit")) +
                    "\n\t\t\t"
                ),
              ]),
        ]),
      ]),
      _c(
        "button",
        {
          staticClass: "vip-home-action",
          attrs: { type: "button" },
          on: { click: _vm.viewRewards },
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("member_level.view_rewards")))]),
          _c("i", {
            staticClass: "el-icon-arrow-right",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "vip-home-level-mark", attrs: { "aria-hidden": "true" } },
      [_c("span", [_vm._v("VIP")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }